<template>
    <v-app>
        <v-app-bar
            app
            color="primary"
            dark
            height="70"
            fixed
        >
            <div class="d-flex align-center white--text">
                <v-img
                alt="Vuetify Logo"
                class="shrink mr-2"
                contain
                src="../../assets/logo.png"
                transition="scale-transition"
                width="50"
                />
                {{ schoolName}}
                
            </div>

            <v-spacer></v-spacer>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-avatar
                        color="secondary"
                        class="mr-6"
                        size="36" 
                        v-bind="attrs"
                        v-on="on"               
                    >
                        <span class="primary--text button">{{ user.initials }}</span>
                    </v-avatar>                
                </template>
                <span>{{ user.name }}</span>
            </v-tooltip>            

            <Logout/>            

        </v-app-bar>              
 
        <v-main class="grey lighten-5">
            <slot></slot>
        </v-main>
    </v-app> 
    
</template>

<script>
import Logout from '../auth/Logout';
import { mapGetters } from 'vuex';

export default {
  name: 'App',

  components: {    
    Logout,
       
  },
   
  data: () => ({
     documentTop: true,     
     floatingButton: false,
     tabs: [
        {id: 1, name: 'Main Menu', route: '/dashboard', display: true},
        // {id: 2, name: 'Edit View Registration', route: '/registration/student-data', display: false},
        //{id: 3, name: 'Term Reports', route: '/term-reports', display: false},        
    ],
    tab: 0,
           
  }),
 
  computed: {
      ...mapGetters({
          getUser: 'auth/getUser',
          schoolName: 'auth/getSchoolName',         
          selectedTab: 'dashboard/getSelectedTab'                         
      }),

      user () {
        return JSON.parse(this.getUser);
      }
      
  },
  methods: {  
      navigation(val){
        //console.log(val);
        //console.log(this.$route.name);

        let route = this.$route.name;          
        switch(val){
        case 0:
            if(route != 'dashboard')
            this.$router.push('/dashboard');  
            break;
        case 1:
            if(route != 'studentData')
            this.$router.push('/registration/student-data');              
            break;
        case 2:
            if(route != 'termReports')            
            this.$router.push('/term-reports'); 
            break;       
        }
      }
  },

  
};
</script>

<style scoped>
    .quick-navigation{
        position: fixed;       
    }
</style>
